import { FundsMarginErrorResponse, FundsMarginSuccessResponse, PlansAlgoverseProps } from '../type';

export enum PAYTMENT_STATUS {
  INITIALIZED = 'INITIALIZED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
  ADD_FUNDS = 'ADD_FUNDS',
}

export type PaymentUIConfig = {
  title: string;
  renderBody: () => JSX.Element | string | React.ReactNode;
  renderFooter: () => React.ReactNode;
};

export enum FUND_PLATFORMS {
  MOBILE = 'MOBILE',
  WEB = 'WEB',
}

export type AlgoversePaymentModalProps = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  orderId: string;
  selectedPlan: PlansAlgoverseProps['activePlan'] | null;
};

export type AlgoversePaymentSuccessResponse = {
  status: 'success';
  data: {
    reference_id: string;
    transaction_id: string;
    user_id: string;
    status: PAYTMENT_STATUS;
    amount: number;
    total_amount: number;
    base_amount: number;
    gst_amount: number;
    error_reason: string | null;
  };
};

export type AlgoversePaymentErrorResponse = {
  status: 'error';
  errors: {
    message: string;
    error_code: string;
    property_path: string | null;
    invalid_value: string | null;
  }[];
};

export type UseAlgoversePaymentReturnType = {
  paymentStatus: PAYTMENT_STATUS;
  setPaymentStatus: (status: PAYTMENT_STATUS) => void;
  marginResponse: FundsMarginSuccessResponse | FundsMarginErrorResponse | undefined;
  algoversePaymentResponse: AlgoversePaymentSuccessResponse | AlgoversePaymentErrorResponse | undefined;
  selectedFoundPlatform: FUND_PLATFORMS;
  setSelectedFoundPlatform: (platform: FUND_PLATFORMS) => void;
  handlePayment: () => Promise<void>;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  countdown: { success: number; pending: number };
  orderId: string;
};
